import React, { Component, Fragment } from 'react';
import cradle from '../assets/cradle.svg';
import seatBelts from '../assets/seat-belts.svg';
import seatWithoutBelts from '../assets/seat-without-belts.svg';
import seatPad from '../assets/seat-pad.svg';
import seatbelts from '../assets/seatbelts.svg';
import SafetyItem from '../components/SafetyItem';
import KidsSafetyValidation from '../../utils/KidsSafetyValidation';
import withRouter from 'components/components/common/withRouter';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

const propTypes = {
  kidsSafety: PropTypes.object.isRequired,
  setKidsSafetyNumber: PropTypes.func.isRequired,
  childrenNumber: PropTypes.number.isRequired
};

class SafetyList extends Component {

  shouldDisableIncrement = () => {
    return new KidsSafetyValidation(this.props).disableIncrement();
  }

  numberLeft = () => {
    return new KidsSafetyValidation(this.props).itemsToChooseLeft();
  }

  isValidForm = () => {
    return new KidsSafetyValidation(this.props).isValidForm();
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.kidsSafety.safetyList.' + key);
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    var disableIncrement = this.shouldDisableIncrement();
    var numberLeft = this.numberLeft();
    return (
      <Fragment>
        <p className="text-color text-center">
          {this.trans('chooseTitle')}
          <span className="val">{numberLeft}</span>
          {this.trans('chooseTitleSufix')}
        </p>

        <ul className="list-none list-safety">
          <SafetyItem
            age={this.t('content.kidsSafety.labels.firstAge')}
            image={cradle}
            title={this.trans('items.cradle')}
            weight={this.t('content.kidsSafety.labels.firstWeight')}
            number={this.props.kidsSafety.cradle}
            propsName="cradle"
            onChange={this.props.setKidsSafetyNumber}
            disableIncrement={disableIncrement}
            className={classNames(
              this.props.kidsSafety.cradle > 0 ? 'list-safety__item--active' : '',
              { 'list-safety__item--disabled': disableIncrement }
            )}
          />
          <SafetyItem
            age={this.t('content.kidsSafety.labels.secondAge')}
            image={seatBelts}
            title={this.trans('items.seatWithSeatBelts')}
            weight={this.t('content.kidsSafety.labels.secondWeight')}
            number={this.props.kidsSafety.seatWithSeatBelts}
            propsName="seatWithSeatBelts"
            onChange={this.props.setKidsSafetyNumber}
            disableIncrement={disableIncrement}
            className={classNames(
              this.props.kidsSafety.seatWithSeatBelts > 0 ? 'list-safety__item--active' : '',
              { 'list-safety__item--disabled': disableIncrement }
            )}
          />
          <SafetyItem
            age={this.t('content.kidsSafety.labels.thirdAge')}
            image={seatWithoutBelts}
            title={this.trans('items.seatWithoutSeatBelts')}
            weight={this.t('content.kidsSafety.labels.thirdWeight')}
            number={this.props.kidsSafety.seatWithoutSeatBelts}
            propsName="seatWithoutSeatBelts"
            onChange={this.props.setKidsSafetyNumber}
            disableIncrement={disableIncrement}
            className={classNames(
              this.props.kidsSafety.seatWithoutSeatBelts > 0 ? 'list-safety__item--active' : '',
              { 'list-safety__item--disabled': disableIncrement }
            )}
          />
          <SafetyItem
            age={this.t('content.kidsSafety.labels.fourthAge')}
            image={seatPad}
            title={this.trans('items.carSeatPad')}
            weight={this.t('content.kidsSafety.labels.fourthWeight')}
            number={this.props.kidsSafety.carSeatPad}
            propsName="carSeatPad"
            onChange={this.props.setKidsSafetyNumber}
            disableIncrement={disableIncrement}
            className={classNames(
              this.props.kidsSafety.carSeatPad > 0 ? 'list-safety__item--active' : '',
              { 'list-safety__item--disabled': disableIncrement }
            )}
          />
          <SafetyItem
            age=""
            image={seatbelts}
            title={this.trans('items.noNeedCarSeat')}
            weight=""
            number={this.props.kidsSafety.noNeedCarSeat}
            propsName="noNeedCarSeat"
            onChange={this.props.setKidsSafetyNumber}
            disableIncrement={disableIncrement}
            className={classNames(
              this.props.kidsSafety.noNeedCarSeat > 0 ? 'list-safety__item--active' : '',
              { 'list-safety__item--disabled': disableIncrement }
            )}
          />
        </ul>
      </Fragment>
    );
  }
}

SafetyList.propTypes = propTypes;

export default withRouter(SafetyList);
